import { FormattedMessage } from 'react-intl'

import { IconHeaderLightbulb } from 'components/Icons'
import { Card } from 'components/Layout'

import { CenterContent } from './CenterContent'

export const Expired = () => (
	<Card>
		<IconHeaderLightbulb />
		<CenterContent>
			<h2>
				<FormattedMessage id='flow.expired.title' defaultMessage='Link is expired or already completed' />
			</h2>
			<p>
				<FormattedMessage
					id='flow.expired.description'
					defaultMessage='It looks like the link has expired or you have already submitted your budget. Please reach out to your bank advisor if you believe this is a mistake.'
				/>
			</p>
		</CenterContent>
	</Card>
)
